import {NgModel} from './ngModel';

export const Role = NgModel.extend({
    _name: 'Role',
});
